export const INITIAL_STATE = {
  companies: [],
  isCompanySelected: false,
  selectedCompany: "",
  companyId: "",
  loading: false,
  company: {
    Name: ""
  },
  companyErrors: {
    Name: ""
  }
};
